var path = 'app/scripts/modules/azure/src/serverGroup/configure/wizard/networkSettings/networkSettings.html';
var html = "<div class=\"row\">\n  <azure-server-group-network-settings-selector command=\"command\"></azure-server-group-network-settings-selector>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;